import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { getUserProfile } from '../services/expenseFirestore';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      console.log('Auth state changed. User:', user?.uid);
      if (user) {
        setLoading(true);
        try {
          const profile = await getUserProfile(user.uid);
          console.log('Fetched user profile:', profile);
          if (profile) {
            setUserProfile(profile);
            setCurrentUser(user);
          } else {
            console.warn('No profile found in Firestore; signing out.');
            await signOut(auth);
            setUserProfile(null);
            setCurrentUser(null);
          }
        } catch (error) {
          console.error('Error fetching user profile in AuthContext:', error);
          setUserProfile(null);
          setCurrentUser(null);
        } finally {
          setLoading(false);
        }
      } else {
        setCurrentUser(null);
        setUserProfile(null);
        setLoading(false);
      }
    });
    return unsubscribe;
  }, []);

  const logout = useCallback(async () => {
    await signOut(auth);
    setUserProfile(null);
  }, []);

  const isAdmin = userProfile?.role === 'admin';
  const isEmployee = userProfile?.role === 'employee';

  const value = {
    currentUser,
    userProfile,
    loading,
    logout,
    isAdmin,
    isEmployee,
    role: userProfile?.role || null,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
